module.exports = __webpack_public_path__ + "static/media/scotland01_wide.831b36bf.jpg";